import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiOutlineMenuAlt4, HiX } from "react-icons/hi";
import { FiArrowRight } from "react-icons/fi";
import copy from "../lib/copy";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/markets", label: "Sectors" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="masthead">
      <div className="shell row">
        <Link to="/" className="mark mark--logo" onClick={() => setOpen(false)} aria-label={copy.brand}>
          <img src="/brand/vitalis-logo.png" alt={copy.brand} className="brand-logo" />
        </Link>

        <nav>
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => isActive ? "is-on" : ""}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="extras">
          <Link to="/contact" className="btn btn--primary">
            Talk to us <FiArrowRight />
          </Link>
          <button className="toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
            {open ? <HiX /> : <HiOutlineMenuAlt4 />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn--ink" onClick={() => setOpen(false)} style={{ marginTop: "1rem", width: "100%", justifyContent: "center" }}>
            Talk to us <FiArrowRight />
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
